// extracted by mini-css-extract-plugin
export default {"container":"D5-z","title":"E5-z","link":"F5-z"};